(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/startsubscription.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/startsubscription.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.behaviors.StartSubscription = svs.tur.start_subscription.behaviors.Subscription.extend({
    options() {
      return {
        entryModel: new svs.tur.start_subscription.models.StartEntry(),
        prefix: 'start'
      };
    },
    onStartSubscription(_ref) {
      let {
        entry,
        options
      } = _ref;
      this.entryModel.reset();
      this.entryModel.set({
        subscriptionEntry: entry,
        subscriptionOptions: options
      });
      this.verifyUser();
    },
    onStartIsVerified() {
      this.getEntryOrAnnouncement(() => {
        if (this.entryModel.has('entry')) {
          this.triggerPrefixMethod('showRegisteredPayment');
        } else {
          this.triggerPrefixMethod('showConfirmSubscription');
        }
      });
    },
    onStartPaymentTypeChosen() {
      if (this.entryModel.get('isPaymentTypeChanged')) {
        this.changePaymentType();
      } else {
        this.triggerPrefixMethod('userConfirmPaymenttype');
      }
    },
    onStartUserConfirmPaymenttype() {
      if (this.entryModel.get('isAutogiro')) {
        this.triggerPrefixMethod('withAutogiro');
      } else {
        this.payWithCard();
      }
    },
    onStartWithAutogiro() {
      if (this.entryModel.get('hasActivePayChannel')) {
        this.getAutogiroInfoAndShowConfirm();
      } else {
        this.getAutogiroInfo();
      }
    },
    onStartSubscriptionDefined() {
      this.view.triggerMethod('saveTrackingFromWager', this, () => this.triggerPrefixMethod('activationSuccess', {
        triggerView: true
      }));
    },
    onStartActivationSuccess() {
      this.pollNewSubscription(() => window.location.href = "".concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?subscriptionId=").concat(this.entryModel.get('newSubId')));
    },
    onStartMakeCardPayment() {
      this.view.triggerMethod('saveTrackingFromWager', this, () => {
        this.view.triggerMethod('activationSuccess');
        this.makeCardPayment("".concat(window.location.protocol, "//").concat(window.location.host, "/").concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?subscriptionId=").concat(this.entryModel.get('newSubId')));
      });
    },
    changePaymentType() {
      svs.tur.start_subscription.radio.request('changeSubscriptionPaymentType', this.entryModel.get('paymentType'), this, () => this.triggerPrefixMethod('userConfirmPaymenttype'));
    },

    onStartShowConfirmSubscription() {
      this.triggerPrefixMethod('showChoosePaymenttype');
    },
    onStartShowChoosePaymenttype() {
      svs.components.Modal.show(svs.tur.start_subscription.views.PaymentPrompt, {
        model: this.entryModel,
        context: this
      }, {
        title: 'Betala',
        contentClass: svs.core.detect.formfactor.mobile() ? 'bg-white' : '',
        doubleWidth: true,
        rightButton: {
          visible: false
        },
        leftButton: {
          text: 'Avbryt',
          visible: true,
          callback: () => {
            const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', this);
            if (typeof (swpCheckout === null || swpCheckout === void 0 ? void 0 : swpCheckout.cleanUpSwedbankPayTransaction) === 'function') {
              this.triggerPrefixMethod('cancelButtonFirstPayBankcardSubscription');
              swpCheckout.cleanUpSwedbankPayTransaction();
            } else {
              this.triggerPrefixMethod('cancelButtonBeforeFirstPayBankcardSubscription');
            }
            const subscriptionId = this.entryModel.get('newSubId');
            subscriptionId && svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId, this, () => {});
            svs.components.Modal.hide();
          }
        }
      });
    },
    onStartShowBankcardPaymenttype() {
      this.showBankcardPaymenttype(this.entryModel, this);
    },
    onStartShowRegisteredPayment() {
      this.getPaymentMethod();
    },
    getPaymentMethod() {
      this.triggerPrefixMethod('trackSelectedPaymenttype');
      if (this.entryModel.get('paymentType') === this.CONSTANTS.PAYMENT_TYPE.BANK_CARD.TYPE) {
        this.triggerPrefixMethod('showBankcardPaymenttype');
      } else {
        this.triggerPrefixMethod('paymentTypeChosen');
      }
    },
    getDialogConfirmMessage() {
      const {
        isAutogiro,
        subscriptionOptions: {
          weeklyCost,
          numberOfBoards,
          jokerPrice,
          gameDays
        }
      } = this.entryModel.attributes;
      return {
        title: 'Starta din prenumeration',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "Prenumerationen kostar ".concat(weeklyCost, " kr/vecka och betalas m\xE5nadsvis i f\xF6rskott").concat(isAutogiro ? ' tillsvidare' : '', "."),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "<strong>Antal rader:</strong> ".concat(numberOfBoards, "<br>\n            ").concat(jokerPrice ? "<strong>Joker:</strong> ".concat(jokerPrice, " kr<br>") : '', "\n            <strong>Speldag:</strong> ").concat(gameDays),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "<a target=\"_blank\" href=\"".concat(svs.core.urlMapping.get('termsIntegrityHome'), "\">L\xE4s villkoren f\xF6r prenumeration</a>"),
          align: svs.ui.dialog.message.align.CENTER
        }]
      };
    },
    getDialogConfirmDefinedMessage() {
      let {
        startTime,
        stopTime,
        amount
      } = this.entryModel.attributes;
      const {
        isAutogiro,
        subscriptionOptions: {
          numberOfBoards,
          jokerPrice,
          gameDays,
          weeklyCost
        }
      } = this.entryModel.attributes;
      startTime = svs.utils.date.FormatTime('d/M', startTime);
      stopTime = svs.utils.date.FormatTime('d/M', stopTime);
      amount = svs.utils.format.Currency(amount);
      return {
        title: "Prenumeration med ".concat(this.entryModel.get('paymentTypeText')),
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "Prenumerationen kostar ".concat(weeklyCost, " kr/vecka och betalas m\xE5nadsvis i f\xF6rskott").concat(isAutogiro ? ' tillsvidare' : '', "."),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "<strong>Antal rader:</strong> ".concat(numberOfBoards, "<br>\n              ").concat(jokerPrice ? "<strong>Joker:</strong> ".concat(jokerPrice, " kr<br>") : '', "\n              <strong>Speldag:</strong> ").concat(gameDays),
          align: svs.ui.dialog.message.align.CENTER
        }, {
          type: svs.ui.dialog.message.TEXT,
          text: "F\xF6r startperioden ".concat(startTime, " - ").concat(stopTime, " \xE4r totala kostnaden ").concat(amount, " kr").concat(isAutogiro ? " och dras prelimin\xE4rt den ".concat(startTime) : '', ". Spel under denna period kan inte annulleras."),
          align: svs.ui.dialog.message.align.CENTER
        }]
      };
    }
  });
})(Backbone, _, svs);

 })(window);